import styled from "styled-components";
import {
	COLOR_TEXT_PRIMARY_B2C,
	FONT_WT_MEDIUM,
	FONT_WT_LIGHT,
	FONT_WT_REGULAR,
	COLOR_WHITE,
	MOBILE_L_BP,
	DESKTOP_SM_BP,
	TABLET_BP,
} from "@website-builder/utilities-index";

export const Container = styled.div`
	box-shadow: 0 9px 20px 0 rgb(0 0 0 / 10%);
	background: ${COLOR_WHITE};
	padding: 20px;
	margin-bottom: 40px;

	.mentorInfo {
		padding-top: 20px;
	}

	.top {
		margin: 0px;
		padding: 0px;
		display: flex;
		list-style: none;
		justify-content: space-between;
	}

	@media only screen and (max-width: ${TABLET_BP - 1}px) {
		padding: 20px;
	}
`;

export const Date = styled.div` 
font-size: 16px;
font-weight: ${FONT_WT_LIGHT},
line-height: 22px;
color: ${COLOR_TEXT_PRIMARY_B2C};

`;
export const Title = styled.div`
	font-size: 20px;
	line-height: 28px;
	font-weight: ${FONT_WT_REGULAR};
	color: ${COLOR_TEXT_PRIMARY_B2C};
	padding-top: 15px;
	padding-bottom: 20px;
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		font-size: 14px;
	}
`;
export const Description = styled.div`
	font-size: 16px;
	line-height: 1.5;
	font-weight: ${FONT_WT_LIGHT};
	color: ${COLOR_TEXT_PRIMARY_B2C};
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		font-size: 14px;
	}
`;

export const Name = styled.div`
	font-size: 16px;
	line-height: 22px;
	font-weight: ${FONT_WT_MEDIUM};
	color: ${COLOR_TEXT_PRIMARY_B2C};
`;

export const About = styled.div`
	font-size: 16px;
	line-height: 22px;
	font-weight: ${FONT_WT_LIGHT};
	color: ${COLOR_TEXT_PRIMARY_B2C};
`;
